import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { getInternetConnectionSpeed } from "modules/systemCheck/utils/getInternetConnectionSpeed";
import { checkInternetConnection } from "modules/systemCheck/utils/checkInternetConnection";
import {
  Actions,
  Warnings,
  trackAction,
  trackWarning,
} from "modules/monitoring";
import { selectInternetSpeedResult } from "../../redux/selectors";
import { setInternetSpeedResult } from "../../redux/systemCheckSlice";

export const InternetSpeedTest = () => {
  const dispatch = useAppDispatch();
  const internetSpeedResult = useSelector(selectInternetSpeedResult);
  const { isDirty } = internetSpeedResult;

  useEffect(() => {
    const testAsync = async () => {
      if (isDirty) {
        dispatch(
          setInternetSpeedResult({
            isLoading: true,
            isDirty: false,
            downloadSpeedMbps: null,
          }),
        );

        const downloadSpeedMbps = await getInternetConnectionSpeed();

        const isSuccessful = checkInternetConnection(downloadSpeedMbps);
        dispatch(
          setInternetSpeedResult({
            isLoading: false,
            isDirty: false,
            downloadSpeedMbps,
          }),
        );

        if (!isSuccessful) {
          trackWarning(Warnings.GEARTEST_INTERNET_CONNECTION_SLOW);
        } else {
          trackAction(Actions.GEARTEST_INTERNET_CONNECTION_OK);
        }
      }
    };

    testAsync();
  }, [isDirty, dispatch]);

  return null;
};
